import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { ResponseCommonSI } from "@interfaces/services/common.interfaces";
import { ComunasSI, RegionesSI } from "@interfaces/services/location.interfaces";
import { BASE_URL, ENDPOINTS } from "@core/config/constants";

@Injectable({
  providedIn: "root",
})
export class LocationService {
  constructor(private _http: HttpClient) {}

  async getRegiones(): Promise<RegionesSI[]> {
    const result = await firstValueFrom<ResponseCommonSI<RegionesSI[]>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.REGION}`)
    );
    return result.payload;
  }

  async getComunas(): Promise<ComunasSI[]> {
    const result = await firstValueFrom<ResponseCommonSI<ComunasSI[]>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.COMUNA}`)
    );
    return result.payload;
  }
}
